import useSWR from 'swr';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {Letter} from './types';

type QueryParams = Record<string, unknown> | undefined;

export function fetchLetterRequest(letterId?: string, params?: QueryParams) {
  return useSWR<Letter, unknown, [string, QueryParams]>(
    [`/api/v1/letters/${letterId}`, params],
    ([url, params]) =>
      letrusAPI(url, {params}).then((response) => response.data),
    {
      shouldRetryOnError: false,
    },
  );
}
